// src/components/layout/Footer.tsx
import {
    Box,
    Container,
    Stack,
    IconButton,
    Typography,
} from "@mui/material";
import {
    GitHub,
    Twitter,
    LinkedIn,
} from "@mui/icons-material";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={(theme) => ({
                mt: "auto",
                borderTop: `1px solid ${theme.palette.brand.accent}`,
                backgroundColor:
                    theme.palette.mode === "dark"
                        ? "rgba(18, 22, 20, 0.72)"
                        : "rgba(249, 247, 243, 0.6)",
                backdropFilter: "blur(8px)",
            })}
        >
            <Container sx={{ py: { xs: 2, sm: 2.5 } }}>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={1.5}
                >
                    {/* Copyright */}
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                            textAlign: { xs: "center", sm: "left" },
                        }}
                    >
                        &copy; {year} Recipe App. All rights reserved.
                    </Typography>

                    {/* Social links */}
                    <Stack direction="row" spacing={1}>
                        <IconButton
                            component="a"
                            href="https://github.com/your-profile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="GitHub"
                            sx={{
                                transition: "transform 120ms ease",
                                "&:hover": { transform: "scale(1.1)" },
                            }}
                        >
                            <GitHub fontSize="small" />
                        </IconButton>

                        <IconButton
                            component="a"
                            href="https://twitter.com/your-profile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Twitter"
                            sx={{
                                transition: "transform 120ms ease",
                                "&:hover": { transform: "scale(1.1)" },
                            }}
                        >
                            <Twitter fontSize="small" />
                        </IconButton>

                        <IconButton
                            component="a"
                            href="https://linkedin.com/in/your-profile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            sx={{
                                transition: "transform 120ms ease",
                                "&:hover": { transform: "scale(1.1)" },
                            }}
                        >
                            <LinkedIn fontSize="small" />
                        </IconButton>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
